export function animateHeroImage(curr, next) {
  anime({
    targets: [curr.image],
    opacity: 0,
    duration: 1000,
    easing: 'linear',
    complete(anim) {
      curr.image.classList.add('u-hide')
      next.image.classList.remove('u-hide')
      anime({
        targets: [next.image],
        opacity: [0, 1],
        duration: 1000,
        easing: 'linear',
      })
    },
  })
}

export function animateNextPost(curr, next) {
  curr.copy.setAttribute('style', 'z-index: 1;')
  curr.image.setAttribute('style', 'z-index: 1;')
  next.copy.classList.remove('u-hide')
  next.image.classList.remove('u-hide')

  curr.copy.addEventListener('animationend', (e) => {
    curr.image.classList.add('u-hide')
    curr.copy.classList.add('u-hide')
    curr.image.classList.remove('animation-squishImage')

    curr.image.setAttribute('style', 'z-index: 0;')
    curr.copy.setAttribute('style', 'z-index: 0;')
  })
  curr.image.classList.add('animation-squishImage')
}

export function animateOnScroll(hero, heroHeight) {
  if (window.innerWidth >= 900) {
    const scroll = window.pageYOffset
    if (scroll < heroHeight) {
      const fadeRate = (scroll / heroHeight) * 1.8

      hero.setAttribute('style', `opacity: ${1 - fadeRate}`)
      document.querySelector('.c-nav__menu-button').classList.add('no-filter')
      document.querySelector('.c-nav__logo').classList.add('no-filter')
      document.querySelector('.c-nav__support--home').classList.add('justify-items')
      document.querySelector('.c-nav__social--hero').classList.add('u-is-hidden')
    }

    if (scroll > heroHeight) {
      hero.setAttribute('style', 'opacity: 0;')
    }

    if (scroll < 300) {
      document.querySelector('.c-nav__menu-button').classList.remove('no-filter')
      document.querySelector('.c-nav__logo').classList.remove('no-filter')
      document.querySelector('.c-nav__support--home').classList.remove('justify-items')
      document.querySelector('.c-nav__social--hero').classList.remove('u-is-hidden')
    }
  }
}
